import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Keys, Routes } from "../Constants";
export var QUESTION_TO_PATH_MOBILE = new Map([[Keys.Application.nationality, Routes.Eligibility.NationalityQuestion], [Keys.Application.stateOfResidence, Routes.Eligibility.ProvinceOfResidenceQuestion], [Keys.Application.educationStatus, Routes.Eligibility.HighestEducationQuestion], [Keys.Application.mostRecentOverallGrade, Routes.Eligibility.OverallGradeQuestion], [Keys.Application.englishProficiencyTest, Routes.Eligibility.EnglishTestsQuestion], [Keys.Application.standardizedTests, Routes.Eligibility.GraduateTestsQuestion]]);
export var PageQuestions = new Map([[1, [Keys.Application.nationality]], [2, [Keys.Application.countryOfResidence]], [3, [Keys.Application.stateOfResidence]], [4, [Keys.Application.validStudyPermitsOrVisas]], [5, [Keys.Application.educationStatus]], [6, [Keys.Application.mostRecentOverallGrade]], [7, [Keys.Application.englishProficiencyTest]], [8, [Keys.Application.standardizedTests]]]);
export var MinutesLeft = {
  LESS_THAN_ONE: '<1 minute left',
  ONE_TO_THREE: '1-3 minutes left',
  TWO_TO_THREE: '2-3 minutes left',
  TWO_TO_FOUR: '2-4 minutes left',
  THREE_TO_FOUR: '3-4 minutes left',
  FOUR_TO_FIVE: '4-5 minutes left',
  FIVE: '5 minutes left'
};
export var MIN_NUMBER_OF_QUESTIONS = 6;
export var MAX_NUMBER_OF_QUESTIONS = 8;
export var TimeLeft = {
  1: MinutesLeft.FIVE,
  2: MinutesLeft.FOUR_TO_FIVE,
  3: MinutesLeft.FOUR_TO_FIVE,
  4: MinutesLeft.THREE_TO_FOUR,
  5: MinutesLeft.THREE_TO_FOUR,
  6: MinutesLeft.TWO_TO_THREE,
  7: MinutesLeft.TWO_TO_THREE,
  8: MinutesLeft.LESS_THAN_ONE
};